"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactSwitch = _interopRequireDefault(require("react-switch"));
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _pages = require("chaire-lib-frontend/lib/components/pages");
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
class ComparisonPanel extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      comparisonIsSelected: _OctaviParameters.default.get('comparisonIsSelected', false),
      filterSelected: _OctaviParameters.default.get('filterSelected', "FilterOne"),
      dataSourceIds: _OctaviParameters.default.dataSourceIds
    };
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onSwitchChange = this.onSwitchChange.bind(this);
    this.updateDataSourceIds = this.updateDataSourceIds.bind(this);
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.on('taxi.dataSources.loaded', this.updateDataSourceIds);
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off('taxi.dataSources.loaded', this.updateDataSourceIds);
  }
  updateDataSourceIds() {
    this.setState({
      dataSourceIds: _OctaviParameters.default.dataSourceIds
    });
  }
  onButtonClick(name) {
    this.setState({
      filterSelected: name
    });
    _OctaviParameters.default.filterSelected = name;
    _ServiceLocator.default.eventManager.emit('taxi.filter.filterSelection.update');
  }
  onSwitchChange() {
    let newState;
    // if comparison is selected --> set comparison to off and active filter one by default
    if (this.state.comparisonIsSelected) {
      newState = {
        comparisonIsSelected: false,
        filterSelected: "FilterOne"
      };
    }
    // if filter was not selected turn it to on and automaticaly select driver if no object was previously selected
    else {
      newState = {
        comparisonIsSelected: true,
        filterSelected: this.state.filterSelected
      };
    }
    this.setState(newState);
    _OctaviParameters.default.comparisonIsSelected = newState.comparisonIsSelected;
    _ServiceLocator.default.eventManager.emit('taxi.filter.comparisonIsSelected.update');
    _OctaviParameters.default.filterSelected = newState.filterSelected;
    _ServiceLocator.default.eventManager.emit('taxi.filter.filterSelection.update');
  }
  render() {
    if (this.state.dataSourceIds.length === 0) {
      return /*#__PURE__*/_react.default.createElement(_pages.LoadingPage, null);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "tr__form-input-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_margin_bottom_small _bottom_border"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_filter_section _space-between-columns _margin_bottom_small"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "_left"
    }, this.props.t('octavi:filters:comparison:sectionName')), /*#__PURE__*/_react.default.createElement(_reactSwitch.default, {
      id: `formFieldTaxiActivitiesComparisonFilter`,
      onChange: this.onSwitchChange,
      checked: this.state.comparisonIsSelected,
      onColor: "#609112",
      height: 25
    })), this.state.comparisonIsSelected && /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_filter_section _space-between-columns"
    }, /*#__PURE__*/_react.default.createElement("button", {
      id: `formFieldComparisonFilterOneSelector`,
      className: this.state.filterSelected == "FilterOne" && this.state.comparisonIsSelected ? "_input _input-select-button _green" : "_input _input-select-button grey",
      type: "button",
      style: {
        display: "inline-block"
      },
      onClick: x => this.onButtonClick("FilterOne")
    }, this.props.t('octavi:filters:comparison:filterOne')), /*#__PURE__*/_react.default.createElement("button", {
      id: `formFieldComparisonFilterTwoSelector`,
      className: this.state.filterSelected == "FilterTwo" && this.state.comparisonIsSelected ? "_input _input-select-button _green" : "_input _input-select-button grey",
      type: "button",
      style: {
        display: "inline-block"
      },
      onClick: x => this.onButtonClick("FilterTwo")
    }, this.props.t('octavi:filters:comparison:filterTwo')))));
  }
}
var _default = exports.default = (0, _reactI18next.withTranslation)()(ComparisonPanel);